
import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import Edit from './edit';
import save from './save';
import metadata from './block.json';
import icons from './icons.js';

registerBlockType(metadata.name, {
	icon: icons.example,
	category: 'custom-c4l-category',
	attributes: {
		title: {
			type: 'string',
		},
		text: {
			type: 'string',
		}
	},
	example: {
		attributes: {
			title: {
				type: "Example Title",
			},
			text: {
				type: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec rutrum congue leo eget malesuada. Vivamus suscipit tortor eget felis porttitor volutpat.",
			}
		}
	},
	edit: Edit,
	save
});
